import { Datagrid, DateField, DateInput, Edit, FunctionField, List, NumberField, NumberInput, ReferenceField, ReferenceInput, required, SelectInput, SimpleForm, TextField, TextInput } from 'react-admin';
import { MyDateInput } from '../constant/MyDateInput';


export const Penilaian_piketList_ppid = () => (
    <List filters={piketFilters}  filterDefaultValues={{"tanggal": new Date().toLocaleDateString("en-CA", {year:"numeric", month: "2-digit"})}}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <DateField source="tanggal" />
            <TextField source="sesi" />
            {/* <FunctionField
                source="petugas1"
                render={record => `<b>${record.petugas1} ${record.n1}</b>`}
            /> */}
            <ReferenceField label="Nama Petugas 1" source="petugas1" reference="petugas_pst" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            

            <DateField source="date_created" />
            <DateField source="tahun_bulan" />
            <TextField source="n1" />
            
        </Datagrid>
    </List>
);

export const Penilaian_piketEdit_ppid = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <DateInput source="tanggal" disabled/>
            <NumberInput source="sesi" disabled/>
            {/* <NumberInput source="petugas1" />
            <NumberInput source="petugas2" />
            <NumberInput source="petugas3" />
            <NumberInput source="petugas4" /> */}

            <div style={{ display: 'flex', direction: 'row', gap: '10px'}}>
                <ReferenceInput source="petugas1" reference="petugas_pst" sort={{ field: 'nama', order: 'ASC' }} perPage={100}>
                    <SelectInput label="Nama Petugas 1" optionText="nama" validate={[required()]} style={{ minWidth: '250px' }}/>
                </ReferenceInput>
                <NumberInput source="n1"  min={1} max={6} />
                <TextInput source="c1" />
            </div>

            <DateInput source="date_created" disabled />
            <DateInput source="tahun_bulan" disabled/>
        </SimpleForm>
    </Edit>
);

const piketFilters = [
    // <SearchInput source="tanggal" alwaysOn />,
    <MyDateInput source="tanggal" parse={val => val.substring(0,7)} alwaysOn />,
    // <DateInput source="tanggal" parse={val => getStringFromDate(val).substring(0,10)} inputFormat="dd MMMM yyyy" alwaysOn />,
];